import DataTile from "./DataTile";
import { fetchVectorsAction} from "../../../actions";
import React from "react";
import {
     bbIsVectorRisk,
    filterObject
} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import RiskRibbon from "../../risk/RiskRibbon";
import Riskmeter from "../BBRiskMeter/Riskmeter";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const calculateVectorQuality = (vectors) => {
        //calculate desired value
        //if all vectors
        if (vectors) {
            const numHighestRiskVectors = Object.keys(filterObject(vectors, (_, vector) => bbIsVectorRisk(vector, 4))).length;

            const numHighRiskVectors = Object.keys(filterObject(vectors, (_, vector) => bbIsVectorRisk(vector, 3))).length;
            const numMediumRiskVectors = Object.keys(filterObject(vectors, (_, vector) => bbIsVectorRisk(vector, 2))).length;
            const numLowRiskVectors = Object.keys(filterObject(vectors, (_, vector) => bbIsVectorRisk(vector, 1))).length;
            const numLowestRiskVectors = Object.keys(filterObject(vectors, (_, vector) => bbIsVectorRisk(vector, 0))).length;

            //Add them together with weighted scores
            //High gets 100 points
            //Medium get 50 points
            //Low gets 20 points
            const highestInput = numHighestRiskVectors * 90;
            const highInput = numHighRiskVectors * 70;
            const mediumInput = numMediumRiskVectors * 50;
            const lowInput = numLowRiskVectors * 30;
            const lowestInput = numLowestRiskVectors * 10;
            const numTotalVectors = numLowestRiskVectors + numLowRiskVectors + numMediumRiskVectors + numHighRiskVectors + numHighestRiskVectors
            const highestScorePossible = numTotalVectors * 100;

            // const numVectors = Object.keys(vectors).length;
            // const numValidCampaigns = Object.keys(filterObject(campaigns, (_, campaign) => bbIsCampaignActive(campaign) )).length;
            // const numActiveCampaigns = Object.keys(campaigns).map((k) => campaigns[k]).filter(campaign => bbIsCampaignActive(campaign)).length;
            // const numTotalVectorsThatCouldStillBreach = numVectorsThatCouldStillBreach
            // const numTotalVectors = numVectors

            return numTotalVectors > 0 ? Math.floor((lowestInput + lowInput + mediumInput + highInput + highestInput)/highestScorePossible * 100)  : 0;
        } else {
            return null;
        }
    }

    const showRiskMeterWith = (stateData) => {
        if (stateData && stateData[customerIdToUse]) {

            try {

                const {
                    [customerIdToUse] : {
                        vectors
                    }
                } = stateData

                const riskScore = calculateVectorQuality(vectors);

                return <div
                    className={""}
                    style={{ marginTop: 15 }}
                >
                    <Riskmeter
                        currentValueText={' '}
                        // width = {125}
                        height = {80}
                        value={riskScore}
                        valueTextFontSize={'16px'}
                        hideNeedle={false}

                    />
                </div>

            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }

    const valueFunction = (stateData) => {
        if (stateData && stateData[customerIdToUse]) {
            // console.log("About to destructure stateData from", __filename, stateData, customerIdToUse);
            try {
                //destructure state data
                // console.log("Inside try About to destructure stateData from", __filename, stateData, customerIdToUse);
                const {
                    [customerIdToUse] : {
                        vectors
                    }
                } = stateData

                const nAMessage = "N/A"
                const percentSuccess = calculateVectorQuality(vectors);

                //stupid check, return, and broadcast problems
                if (percentSuccess === nAMessage || percentSuccess <= 0) {
                    return nAMessage
                } else if (!isNaN(percentSuccess) && percentSuccess >= 0 && percentSuccess <= 100) {
                    return `${percentSuccess}%`
                } else {
                    console.warn("TileVectorsNotValid failed stupid check. Wanted number of successful attacks.  used: numSuccessfulAttacks");
                    return null
                }
            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }

    const translateValueToRisk = (value) => {
        if (!value || value === "N/A") {
            return null
        } else {
            try {
                //strip the %
                const stripped = parseInt(value.slice(0, -1));
                if (typeof stripped !== "number") {
                    return null
                } else if (stripped > 100 || stripped < 0) {
                    console.warn("translateValueToRisk is out of bounds", __filename)
                    return null
                } else if (stripped < 20) {
                    return 0
                } else if (stripped <= 40 ) {
                    return 1
                } else if (stripped <= 60) {
                    return 2
                } else if (stripped <= 80) {
                    return 3
                } else {
                    return 4
                }
            } catch(e) {
                console.warn(e);
                return null
            }
        }
    }

    // const colorFunction = (stateData) => {
    //     const num = valueFunction(stateData);
    //     return bbTranslateRiskToColor(translateValueToRisk(num));
    // }

    const riskRibbon = (stateData) => {
        const num = translateValueToRisk(valueFunction(stateData));
        return num
            ? <RiskRibbon ratingBy5={num} />
            : null;
    }


    return (
        <DataTile
            // colorBgFunction={colorFunction}
            subTitle="Vector Quality"
            tipText={`The average breach likelihood across all Vectors. A higher score indicates better options for an attacker.`}
            icon={<div
                className={""}
                style={{ marginTop: 15 }}
            >
                <Riskmeter
                    currentValueText={' '}
                    // width = {125}
                    height = {80}
                    value={0}
                    valueTextFontSize={'16px'}
                    // hideNeedle

                />
            </div>}
            // icon={<BBIconBombs style={{fontSize: "70px"}}/>}
            iconFunction={showRiskMeterWith}
            stateName="customer"
            stateElement="customers"
            useDeepDataStore
            // dontFetch
            deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].vectors : null : null}
            stateLoaderName="loadingVectors"
            stateLoaderError="loadingVectorsError"
            stateFetchAction={fetchVectorsAction({
                customerId: customerIdToUse
            })}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={riskRibbon}
            // showKRIRibbon
            requiresModule={"perimeter"}
        />
    )

}

export default Tile;